import { useState } from 'react'
import { authErrorMessage } from '../../lib/authErrors'
import { getLastUsedMethod } from '../../lib/lastUsedMethod'
import LastUsedBadge from './LastUsedBadge'

type Props = {
  signIn: () => Promise<unknown>
  onError: (message: string) => void
}

export default function GoogleSignIn({ signIn, onError }: Props) {
  const [pending, setPending] = useState(false)

  async function handleClick() {
    onError('')
    setPending(true)
    try {
      await signIn()
    } catch (err) {
      onError(authErrorMessage(err))
      setPending(false)
    }
  }

  return (
    <>
      <div className="relative">
        <button
          type="button"
          onClick={handleClick}
          disabled={pending}
          className="flex h-11 w-full items-center justify-center gap-2.5 rounded-[10px] border border-stone-200 bg-white text-[15px] font-medium text-stone-900 shadow-[0_1px_2px_rgba(28,25,23,0.05)] transition-colors enabled:hover:bg-stone-50 disabled:opacity-60"
        >
          <GoogleIcon />
          Continue with Google
        </button>
        {getLastUsedMethod() === 'google' && <LastUsedBadge />}
      </div>

      <div className="my-5 flex items-center gap-3 text-sm text-stone-500">
        <span className="h-px flex-1 bg-stone-200" />
        or
        <span className="h-px flex-1 bg-stone-200" />
      </div>
    </>
  )
}

function GoogleIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden className="size-5">
      <path fill="#4285F4" d="M23.52 12.27c0-.85-.08-1.67-.22-2.45H12v4.64h6.46a5.52 5.52 0 0 1-2.4 3.62v3h3.88c2.27-2.09 3.58-5.17 3.58-8.81Z" />
      <path fill="#34A853" d="M12 24c3.24 0 5.96-1.07 7.94-2.9l-3.88-3.02c-1.07.72-2.45 1.15-4.06 1.15-3.12 0-5.77-2.11-6.71-4.95H1.28v3.11A12 12 0 0 0 12 24Z" />
      <path fill="#FBBC05" d="M5.29 14.28A7.2 7.2 0 0 1 4.91 12c0-.79.14-1.56.38-2.28V6.61H1.28a12 12 0 0 0 0 10.78l4.01-3.11Z" />
      <path fill="#EA4335" d="M12 4.77c1.76 0 3.34.61 4.59 1.8l3.44-3.44A11.94 11.94 0 0 0 12 0 12 12 0 0 0 1.28 6.61l4.01 3.11C6.23 6.88 8.88 4.77 12 4.77Z" />
    </svg>
  )
}
